import { TabPill } from 'types/tabs';

/* eslint-disable import/prefer-default-export */
export const mainTabs: TabPill[] = [
  { id: 'activities', label: 'Activities' },
  { id: 'notes', label: 'Notes' },
  { id: 'timeline', label: 'Timeline' },
  { id: 'attachments', label: 'Attachment' }
];
